import styled from "styled-components";

import { visuallyHiddenCss } from "../../style-utilities/visually-hidden";
import FieldErrorBase from "../FieldError";
import HelperTextBase from "../HelperText";
import LabelBase from "../Label";

export const Field = styled.div``;

export const ErrorMessage = styled(FieldErrorBase)`
  margin-top: 8px;
`;

export const HelperText = styled(HelperTextBase)`
  margin-top: 8px;

  ${({ isVisuallyHidden }) => isVisuallyHidden && visuallyHiddenCss}
`;

export const Label = styled(LabelBase)`
  display: block;
  margin-bottom: 10px;
`;
